<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="价格申请"
      width="1350px"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :disabled="disabled"
        :rules="ruleValidate"
        :model="application"
        class="form"
        label-width="100px">
      <div class="title" style="font-weight: bold;font-size: large">申请单信息</div>
      <el-row>
        <el-col :span="8">
          <el-form-item label="流程编号:" style="font-weight: bold;">
            <span>{{application.applicationNo}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="申请人:" style="font-weight: bold;">
            <span>{{application.creatorName}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="申请部门:" style="font-weight: bold;">
            <span>{{application.creatorDepartment}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="title" style="font-weight: bold;font-size: large">价格申请清单</div>
      <div style="margin-bottom: 10px">
        <el-button
            type="primary"
            @click="$refs.selectMaterial.open()">
          添加物料
        </el-button>
      </div>
      <el-table class="table" :data="application.detailList" border>
        <el-table-column align="center" type="index" label="#" width="50"/>
        <el-table-column prop="materialNo" label="物料编号" min-width="120"/>
        <el-table-column prop="materialName" label="物料名称" width="250"/>
        <el-table-column prop="specification" label="规格型号" min-width="120"/>
        <el-table-column prop="productLevelName" label="产品层次" min-width="120"/>
        <el-table-column prop="costPrice" label="成本价" align="center" min-width="100">
          <template slot-scope="scope">
            <el-input v-model="scope.row.costPrice"/>
          </template>
        </el-table-column>
        <el-table-column prop="standardPrice" label="A价" align="center" min-width="100">
          <template slot-scope="scope">
            <el-input v-model="scope.row.standardPrice"/>
          </template>
        </el-table-column>
        <el-table-column prop="level1Price" label="B价" align="center" min-width="100">
          <template slot-scope="scope">
            <el-input v-model="scope.row.level1Price"/>
          </template>
        </el-table-column>
        <el-table-column prop="level2Price" label="C价" align="center" min-width="100">
          <template slot-scope="scope">
            <el-input v-model="scope.row.level2Price"/>
          </template>
        </el-table-column>
        <el-table-column prop="level3Price" label="D价" align="center" min-width="100">
          <template slot-scope="scope">
            <el-input v-model="scope.row.level3Price"/>
          </template>
        </el-table-column>
        <el-table-column prop="开始日期" label="开始日期" align="center" min-width="150">
          <template slot-scope="scope">
            <el-date-picker
                v-model="scope.row.beginDate"
                value-format="yyyy-MM-dd"/>
          </template>
        </el-table-column>
        <el-table-column prop="结束日期" label="结束日期" align="center" min-width="150">
          <template slot-scope="scope">
            <el-date-picker
                v-model="scope.row.endDate"
                value-format="yyyy-MM-dd"/>
          </template>
        </el-table-column>
        <el-table-column prop="note" label="备注" align="center" min-width="120">
          <template slot-scope="scope">
            <el-input v-model="scope.row.note"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="160" fixed="right">
          <template slot-scope="scope">
            <el-button type="danger" @click="deleteHandle(scope)"> 删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="submitHandle">确定</el-button>
    </span>
    <material-select ref="selectMaterial" @select="selectMaterial"/>
  </el-dialog>
</template>


<script>

  import MaterialSelect from "@/views/information/Material/MaterialSelect";

  export default {
    components: {MaterialSelect},
    data() {
      return {
        priceEditAuth: this.$auth(394),
        disabled: false,
        contentLoading: false,
        dialogVisible: false,
        submitLoading: false,
        application: {
          creatorName: "",
          creatorDepartment: "",
          createTime: "",
          submitTime: "",
          passTime: "",
          applicationNo: "",
          detailList: [],
          pkId:0,
        },
        ruleValidate: {
          // standardFloatingPrice: { required: true, message: "请输入A浮价", trigger: "blur" },
        },
      };
    },
    methods: {
      open(row, edit) {
        this.disabled = !edit;
        this.dialogVisible = true;
        if (row) {
          this.getData(row.pkId);
        }
        this.$nextTick(() => {
        });
      },

      // 根据物料id查询价格信息
      getData(id) {
        this.contentLoading = true;
        this.$http
          .get("basic", `materialPriceApplications/${id}`)
          .then((resp) => {
            if (resp.success) {
              this.application = Object.assign(this.application, resp.data);
            }
            this.contentLoading = false;
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      submitHandle() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            if (this.application.pkId) {
              this.$http.put("basic","materialPriceApplications",this.application)
                .then(resp=>{
                  if (resp.success) {
                    this.$emit("save-success");
                    this.$message.success("保存成功");
                  }
                }).catch(()=>{
                  this.submitLoading=false;
                });
            }else{
              this.$http
                .post("basic", "materialPriceApplications", this.application)
                .then((res) => {
                  this.submitLoading = false;
                  if (res.success) {
                    this.$emit("save-success");
                    this.$message.success("保存成功");
                  }
                  this.dialogVisible = false;
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
            this.submitLoading = false;
            this.dialogVisible = false;
          }
        });
      },

      // 添加物料
      selectMaterial(row) {
        console.log(row);
        let obj = {
          materialId: row.id,
          materialNo: row.no,
          materialName: row.name,
          specification: row.zmyxh,
          unit: row.unit,
          standardPrice: row.standardPrice,
          costPrice: row.costPrice,
          level1Price: row.level1Price,
          level2Price: row.level2Price,
          level3Price: row.level3Price,
          productLevelName:row.productLevelName,
        };
        this.application.detailList.push(obj);
      },

      deleteHandle(scope) {
        this.application.detailList.splice(scope.$index, 1);
      },
    },
  };
</script>